export default __webpack_public_path__ + "static/media/kehadiran.ba3915b8.png";